var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"flex":""}},[_c('div',{staticClass:"minigame-page"},[_c('div',{staticClass:"minigame-page__playground"},[_c('iframe',{attrs:{"src":_vm.gameSrc,"frameborder":"0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }